/// <amd-module name="SuiteCommerce.GridOrder.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GridOrder.Model", ["require", "exports", "Backbone", "underscore", "SuiteCommerce.GridOrder.Common.DependencyProvider", "SuiteCommerce.GridOrder.Cell.Model", "SuiteCommerce.GridOrder.Row.Collection", "SuiteCommerce.GridOrder.MatrixItemOption.Model", "SuiteCommerce.GridOrder.Cell.Collection", "SuiteCommerce.GridOrder.Row.Model", "SuiteCommerce.GridOrder.MatrixChildItem.Model", "SuiteCommerce.GridOrder.Configuration", "SuiteCommerce.GridOrder.PriceSchedule.Model"], function (require, exports, Backbone_1, _, DependencyProvider_1, GridOrder_Cell_Model_1, GridOrder_Row_Collection_1, GridOrder_Cell_MatrixItemOption_Model_1, GridOrder_Cell_Collection_1, GridOrder_Row_Model_1, GridOrder_Cell_MatrixChildItem_Model_1, GridOrder_Configuration_1, GridOrder_Cell_PriceSchedule_Model_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var GridOrderModel = /** @class */ (function (_super) {
        __extends(GridOrderModel, _super);
        function GridOrderModel(options) {
            var _this = _super.call(this, options) || this;
            _this.headerCollection = new Backbone_1.Collection();
            _this.set('rowsCollection', new GridOrder_Row_Collection_1.RowCollection());
            _this.buildRows();
            _this.unset('rows');
            _this.buildHeaders();
            _this.unset('headers');
            return _this;
        }
        Object.defineProperty(GridOrderModel.prototype, "columnMatrixOption", {
            get: function () {
                return this.get('columnMatrixOption');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(GridOrderModel.prototype, "rowMatrixOption", {
            get: function () {
                return this.get('rowMatrixOption');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(GridOrderModel.prototype, "headers", {
            get: function () {
                return this.get('headers');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(GridOrderModel.prototype, "rows", {
            get: function () {
                return this.get('rows');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(GridOrderModel.prototype, "headerCollection", {
            get: function () {
                return this.get('headerCollection');
            },
            set: function (collection) {
                this.set('headerCollection', collection);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(GridOrderModel.prototype, "rowsCollection", {
            get: function () {
                return this.get('rowsCollection');
            },
            set: function (collection) {
                this.set('rowsCollection', collection);
            },
            enumerable: true,
            configurable: true
        });
        GridOrderModel.prototype.buildRows = function () {
            var _this = this;
            _.each(this.rows, function (row) {
                var cellsCollection = new GridOrder_Cell_Collection_1.CellCollection();
                _.each(row.matrixChildItems, function (matrixChildItem) {
                    cellsCollection.add(new GridOrder_Cell_MatrixChildItem_Model_1.MatrixChildItemModel(matrixChildItem));
                });
                cellsCollection.on('change', function () {
                    _this.trigger('change');
                });
                var rowModel = new GridOrder_Row_Model_1.RowModel({ cellsCollection: cellsCollection });
                if (_this.hasRowOption()) {
                    // First cell of each row is Matrix Item Option
                    var matrixItemOptionModel = new GridOrder_Cell_MatrixItemOption_Model_1.MatrixItemOptionModel(row.matrixOptionDetail);
                    cellsCollection.unshift(matrixItemOptionModel);
                }
                else if (rowModel.hasPricesSchedules()) {
                    // First cell of each row is empty
                    cellsCollection.unshift(new GridOrder_Cell_MatrixItemOption_Model_1.MatrixItemOptionModel());
                }
                _this.rowsCollection.add(rowModel);
                // Set prices schedules row
                if (GridOrder_Configuration_1.GridOrderConfiguration.isQuantityPricingEnabled
                    && rowModel.hasPricesSchedules()
                    && !DependencyProvider_1.ProfileModel.getInstance().hidePrices()) {
                    _this.setPricesSchedulesRow(rowModel);
                }
            });
        };
        GridOrderModel.prototype.buildHeaders = function () {
            var _this = this;
            if (this.headers.length > 0) {
                if (this.hasRowOption() || this.hasPricesSchedules()) {
                    // The first header cell is empty
                    this.headerCollection.add(new GridOrder_Cell_MatrixItemOption_Model_1.MatrixItemOptionModel());
                }
                _.each(this.headers, function (matrixOption) {
                    var matrixOptionModel = new GridOrder_Cell_MatrixItemOption_Model_1.MatrixItemOptionModel(matrixOption);
                    _this.headerCollection.add(matrixOptionModel);
                });
            }
        };
        GridOrderModel.prototype.setPricesSchedulesRow = function (rowModel) {
            var pricesSchedulesByItem = rowModel.getPricesSchedules();
            var priceScheduleCellsCollection = new GridOrder_Cell_Collection_1.CellCollection();
            _.each(pricesSchedulesByItem, function (priceScheduleItem) {
                var priceSchedule = priceScheduleItem.pricesSchedule;
                var matrixChildInternalId = priceScheduleItem.internalId;
                var optionNotAvailable = priceScheduleItem.optionNotAvailable;
                var priceScheduleModel = new GridOrder_Cell_PriceSchedule_Model_1.PriceScheduleModel({
                    priceSchedule: priceSchedule,
                    matrixChildInternalId: matrixChildInternalId,
                    optionNotAvailable: optionNotAvailable,
                    parentRowCID: rowModel.cid,
                });
                priceScheduleCellsCollection.add(priceScheduleModel);
            });
            if (this.hasRowOption() || rowModel.hasPricesSchedules()) {
                priceScheduleCellsCollection.unshift(new GridOrder_Cell_PriceSchedule_Model_1.PriceScheduleModel({
                    parentRowCID: rowModel.cid,
                }));
            }
            this.rowsCollection.add(new GridOrder_Row_Model_1.RowModel({ cellsCollection: priceScheduleCellsCollection }));
        };
        GridOrderModel.prototype.hasRowOption = function () {
            return !!this.rowMatrixOption;
        };
        GridOrderModel.prototype.hasPricesSchedules = function () {
            return !!this.rowsCollection.find(function (rowModel) {
                return rowModel.hasPricesSchedules();
            });
        };
        GridOrderModel.prototype.getQuantityTotal = function () {
            var quantitiesSummary;
            if (this.columnMatrixOption && this.rowMatrixOption) {
                // Get quantities summary grouped by column when the matrix item has two dimensions
                quantitiesSummary = this.getQuantitiesSummaryByColumn();
            }
            else {
                // Get quantities summary when item has one dimension
                quantitiesSummary = this.getQuantitiesSummaryForSingleDimension();
            }
            return _.reduce(quantitiesSummary, function (memo, quantity) {
                return memo + quantity;
            }, 0);
        };
        GridOrderModel.prototype.getQuantitiesSummaryByColumn = function () {
            var _this = this;
            var quantitiesSummary = {};
            // Initialize object to summarize each column
            this.headerCollection.each(function (matrixChildOption) {
                var label = matrixChildOption.label;
                if (label) {
                    quantitiesSummary["column_index-" + label] = 0;
                }
            });
            this.headerCollection.each(function (matrixChildOption) {
                if (matrixChildOption.internalId) {
                    var label_1 = matrixChildOption.label;
                    var sourceFrom_1 = matrixChildOption.sourceFrom;
                    _this.rowsCollection.each(function (rowModel) {
                        var matrixChildItemModel = rowModel.cellsCollection.find(function (cell) {
                            return !!(cell && (cell.get(sourceFrom_1) === label_1) && cell.quantityIsValid());
                        });
                        if (matrixChildItemModel) {
                            quantitiesSummary["column_index-" + label_1] += matrixChildItemModel.quantity;
                        }
                    });
                }
            });
            return quantitiesSummary;
        };
        GridOrderModel.prototype.getQuantitiesSummaryForSingleDimension = function () {
            var quantitiesSummary = {};
            this.rowsCollection.each(function (rowModel) {
                rowModel.cellsCollection.each(function (cellModel) {
                    var internalId = cellModel.internalId;
                    if (cellModel
                        && GridOrder_Cell_Model_1.isInstanceOf(cellModel, GridOrder_Cell_MatrixChildItem_Model_1.MatrixChildItemModel)
                        && internalId && cellModel.quantityIsValid()) {
                        quantitiesSummary[internalId] = cellModel.quantity;
                    }
                });
            });
            return quantitiesSummary;
        };
        GridOrderModel.prototype.getSubtotal = function () {
            var subtotal = 0;
            if (!DependencyProvider_1.ProfileModel.getInstance().hidePrices()) {
                this.rowsCollection.each(function (rowModel) {
                    var rowSubtotal = 0;
                    rowModel.cellsCollection.each(function (cellModel) {
                        if (GridOrder_Cell_Model_1.isInstanceOf(cellModel, GridOrder_Cell_MatrixChildItem_Model_1.MatrixChildItemModel)
                            && cellModel.internalId && cellModel.quantityIsValid()) {
                            var cellSubtotal = 0;
                            var currentQuantity_1 = isNaN(cellModel.quantity) ? 0 : cellModel.quantity;
                            var itemMaximumQuantity_1 = cellModel.maximumQuantity;
                            if (cellModel.onlineCustomerPriceDetails && cellModel.onlineCustomerPriceDetails.priceschedule) {
                                var pricesSchedule = cellModel.onlineCustomerPriceDetails.priceschedule;
                                var currentPrice = _.find(pricesSchedule, function (priceSchedule) {
                                    var matchMinimumQuantity = currentQuantity_1 >= priceSchedule.minimumquantity;
                                    var matchMaximumQuantity = !priceSchedule.maximumquantity
                                        ? true
                                        : currentQuantity_1 < priceSchedule.maximumquantity;
                                    if (itemMaximumQuantity_1 === priceSchedule.maximumquantity
                                        && itemMaximumQuantity_1 === priceSchedule.minimumquantity
                                        && currentQuantity_1 >= priceSchedule.maximumquantity) {
                                        matchMaximumQuantity = true;
                                    }
                                    return matchMinimumQuantity && matchMaximumQuantity;
                                });
                                cellSubtotal = currentPrice && currentQuantity_1 ? currentPrice.price * currentQuantity_1 : 0;
                            }
                            else {
                                cellSubtotal = cellModel.onlineCustomerPriceDetails.onlinecustomerprice * currentQuantity_1;
                            }
                            rowSubtotal += cellSubtotal;
                        }
                    });
                    subtotal += rowSubtotal;
                });
            }
            return subtotal || 0;
        };
        GridOrderModel.prototype.clearQuantities = function () {
            this.rowsCollection.each(function (rowModel) {
                rowModel.cellsCollection.each(function (model) {
                    if (GridOrder_Cell_Model_1.isInstanceOf(model, GridOrder_Cell_MatrixChildItem_Model_1.MatrixChildItemModel)) {
                        model.quantity = 0;
                    }
                });
            });
        };
        GridOrderModel.prototype.getMatrixDimensions = function () {
            var matrixOptions = [this.columnMatrixOption, this.rowMatrixOption];
            return _.filter(matrixOptions, function (matrixOption) {
                return !!matrixOption;
            });
        };
        GridOrderModel.prototype.quantitiesAreValid = function () {
            var quantitiesAreValid = true;
            this.rowsCollection.each(function (rowModel) {
                rowModel.cellsCollection.each(function (model) {
                    if (GridOrder_Cell_Model_1.isInstanceOf(model, GridOrder_Cell_MatrixChildItem_Model_1.MatrixChildItemModel)) {
                        quantitiesAreValid = quantitiesAreValid && model.quantityIsValid();
                    }
                });
            });
            return quantitiesAreValid;
        };
        return GridOrderModel;
    }(Backbone_1.Model));
    exports.GridOrderModel = GridOrderModel;
});
